import { render, staticRenderFns } from "./h5Jump.vue?vue&type=template&id=81d748e4&scoped=true&"
import script from "./h5Jump.vue?vue&type=script&lang=js&"
export * from "./h5Jump.vue?vue&type=script&lang=js&"
import style0 from "./h5Jump.vue?vue&type=style&index=0&id=81d748e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d748e4",
  null
  
)

export default component.exports